import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";

export const ChildProgramsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .header-with-results-count {
    display: flex;
    flex-direction: row;
    align-items: center;
    ${responsive.MOBILE`
      margin: 16px 0;
    `}
  }
  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 2px 9px 4px 9px;
    border-radius: 8px;
    height: 28px;
  }

  .semi-header {
    display: flex;
    padding: 16px 16px 16px 16px;
    justify-content: flex-end;
    ${responsive.MOBILE`
      padding: 0 8px 0 16px;
    `}
  }
`;
